import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Initialize Firebase with empty config for now (will be configured via window variables)
const config = {
  apiKey: window.$firebaseConfig?.apiKey || '',
  authDomain: window.$firebaseConfig?.authDomain || '',
  databaseURL: window.$firebaseConfig?.databaseURL || '',
  projectId: window.$firebaseConfig?.projectId || '',
  storageBucket: window.$firebaseConfig?.storageBucket || '',
  messagingSenderId: window.$firebaseConfig?.messagingSenderId || '',
};

const firebaseApp = initializeApp(config);
const db = getFirestore(firebaseApp);

export default db;
